import { FIRST_OWNER } from 'constants/holders/holderTypes';

export const getIsFirstOwner = typeHolder => typeHolder === FIRST_OWNER;
